import * as React from 'react';
import { cn } from '@/lib/utils';

export interface DefinitionGridItem {
  label: string;
  value: React.ReactNode;
}

export interface DefinitionGridProps {
  items: DefinitionGridItem[];
  labelWidth?: string;
  className?: string;
}

const DefinitionGrid = React.forwardRef<HTMLDListElement, DefinitionGridProps>(
  ({ items, labelWidth = '7.5rem', className }, ref) => (
    <dl
      ref={ref}
      data-slot="definition-grid"
      className={cn('grid gap-x-4 gap-y-2 text-sm', className)}
      style={{ gridTemplateColumns: `${labelWidth} minmax(0, 1fr)` }}
    >
      {items.map(({ label, value }, index) => (
        <React.Fragment key={`${index}-${label}`}>
          <dt className="revy-cjk text-xs leading-[1.5] text-muted-foreground">{label}</dt>
          <dd className="revy-cjk revy-figure min-w-0 leading-[1.5]">{value}</dd>
        </React.Fragment>
      ))}
    </dl>
  ),
);
DefinitionGrid.displayName = 'DefinitionGrid';

export { DefinitionGrid };
export default DefinitionGrid;
